import { Sprite, CanvasTexture, SpriteMaterial, Box3, Vector3, LinearFilter } from "three";
import { hideAndRemove } from "../scripts/changeObjectParams/helpers";

export function createTextSprite(text) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const paddingX = 24;
    const paddingY = 12;

    const fontSize = 32;
    const font = `500 ${fontSize}px "Golos Text"`;

    context.font = font;

    const textWidth = context.measureText(text).width;

    const width = textWidth + paddingX * 2;
    const height = fontSize + paddingY * 2;

    const dpr = window.devicePixelRatio || 1;

    const QUALITY = 3;

    canvas.width = width * dpr * QUALITY;
    canvas.height = height * dpr * QUALITY;

    context.scale(dpr * QUALITY, dpr * QUALITY);

    context.font = font;

    context.fillStyle = "white";
    roundRect(context, 0, 0, width, height, 10);
    context.fill();

    context.strokeStyle = "#eaeef1";
    context.lineWidth = 2;
    roundRect(context, 1, 1, width - 2, height - 2, 10);
    context.stroke();

    context.fillStyle = "#000";
    context.textAlign = "center";
    context.textBaseline = "middle";

    context.fillText(text, width / 2, height / 2);

    const texture = new CanvasTexture(canvas);
    texture.needsUpdate = true;

    texture.minFilter = LinearFilter;
    texture.magFilter = LinearFilter;

    texture.generateMipmaps = false;
    texture.anisotropy = 16;

    const material = new SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: false,
    });

    const sprite = new Sprite(material);

    const aspect = width / height;
    const WORLD_HEIGHT = 0.25;

    sprite.scale.set(WORLD_HEIGHT * aspect, WORLD_HEIGHT, 1);

    sprite.center.set(0.5, 0.5);

    sprite.material.depthTest = false;
    sprite.renderOrder = 999;

    sprite.visible = false;

    return sprite;
}

function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
}

export const TEXT_MAP = {
    sha: "ША",
    shk: "ШК",
    shi: "ШИ",
    shir: "ШИР",
    shio: "ШИО",
    ship: "ШИП",
};

export const addLabelText = async (wardrobe, type) => {
    await document.fonts.ready;

    const label = createTextSprite(TEXT_MAP[type]);

    const box = new Box3().setFromObject(wardrobe);
    const center = new Vector3();
    const size = new Vector3();

    box.getCenter(center);
    box.getSize(size);

    label.position.set(center.x - wardrobe.position.x, size.y + 0.2, center.z - wardrobe.position.z);

    wardrobe.add(label);
};

export const removeSpritesInObject = (object) => {
    if (!object || typeof object.traverse !== "function") {
        console.error("invalid object", object);
        return;
    }

    const spritesToRemove = [];

    object.traverse((child) => {
        if (child.isSprite) {
            spritesToRemove.push(child);
        }
    });

    spritesToRemove.forEach((sprite) => {
        hideAndRemove(sprite);
    });
};
